import React from "react";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import HelpIcon from "@mui/icons-material/HelpOutlineOutlined";
import { Grid, Typography } from "@mui/material";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";

export default function SeoInformationCard() {
  return (
    <Grid item xs={12}>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <HelpIcon color="primary" />
          <Typography style={{ paddingLeft: ".25em" }}>How to use</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography style={{ textAlign: "left" }}>
            <p>
              This page is for uploading iAuditor templates to Crowdin for
              translation. Once translation is complete you can import the
              translation to create a new translatated template in the same
              organisation as the source template.
            </p>
            <ul>
              <li>
                <b>Template ID</b> - The iAuditor template ID (i.e.
                template_1554bcca99ea4ca6b20b089538c1f096)
              </li>
              <li>
                <b>Crowdin Directory</b> - The directory name in Crowdin
              </li>
              <li>
                <b>Language</b> - The available list of translations languages
                in Crowdin
              </li>
            </ul>
          </Typography>
        </AccordionDetails>
      </Accordion>
    </Grid>
  );
}
